"use strict";
var UsingObservable_1 = require('./UsingObservable');
exports.using = UsingObservable_1.UsingObservable.create;
//# sourceMappingURL=using.js.map


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/rxjs/observable/using.js
// module id = ../../../../rxjs/observable/using.js
// module chunks = 4